import React from 'react';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AvatarDropdown from './AvatarDropdown';

const SearchInput = () => (
  <div className="flex">
    <button className="rounded-full bg-gradient px-4 ml-2 text-white flex items-center text-xs focus:outline-none shadow-lg">
      <FontAwesomeIcon icon={faArrowRight} />
    </button>
  </div>
);

const Navbar = () => {
  return (
    <nav className="flex justify-end px-4">
      <div className="">
        <AvatarDropdown />
      </div>
    </nav>
  );
};

export default Navbar;
